<template>
    <div class="cmp-banners">
        <div class="banners rendered" :style="sliderStyle">
            <div v-for="banner in models" class="banner" :style="banner.style">
                <a :href="banner.clickUrl" target="_blank" rel="nofollow">
                    <v-lazy-image :src="banner.imgUrl" alt="Banner" width="480" height="60"></v-lazy-image>
                </a>
            </div>
        </div>
        <a v-if="models.length > 1" href="#" class="previous" @click.prevent="previous" title="Go Back" aria-label="Go back">
            <icon type="solid" name="faBackward" aria-hidden="true"></icon>
        </a>
        <a v-if="models.length > 1" href="#" class="next" @click.prevent="next"  title="Go Forward">
            <icon type="solid" name="faForward" aria-hidden="true"></icon>
        </a>
    </div>
</template>

<script>import script from './BannersComponent';
    export default script;</script>

<style lang="less">
    @import "./BannersComponent.less";
</style>
